const SectionProfileBase = Class(
	/**
	 * @lends {SectionProfileBase#}
	 */
	{
		__NAME: 'SectionProfileBase',

		bodyClass: 'small-nav grey',

		_ready: function(){
			if( this.isReady ){
				return;
			}
			this.ready();
		},

		draw: function(){
			this._drawBase();
		},

		_drawBase: function(){
			this._mainNode = mkE({
				tag: 'div',
				id: 'profile',
				className: 'container',
				els: [
					this._container = mkE({
						tag: 'div',
						className: 'profile-container',
						els: [
							this._content = mkE({
								tag: 'div',
								className: 'profile-content'
							})
						]
					})
				]
			});
			let menuItems = [
				{
					name: 'activeEvents',
					url: D.url('/profile/events'),
					caption: D.Lang.get('profile.menu.activeEvents')
				},
				{
					name: 'pastEvents',
					url: D.url('/profile/past'),
					caption: D.Lang.get('profile.menu.pastEvents')
				}
			];

			/*if( D.LV ){
				menuItems.push({
					name: 'user-content',
					url: D.url('/user-content/my'),
					caption: D.Lang.get('profile.menu.userContent')
				});
			}*/

			if (D.AFFILIATE_ENABLED) {
				menuItems.push({
					name: 'affiliate',
					url: D.url('/profile/affiliate'),
					caption: D.Lang.get('profile.menu.affiliate')
				});
			}

			menuItems.push({
				name: 'edit',
				url: D.url('/profile/edit'),
				caption: D.Lang.get('profile.menu.edit')
			});

			this._tabs = new T.MainTabs({
				items: menuItems,
				active: this.name
			});
			this._tabs.prepend(this._container);

			this._mainNode.append(this.layout.ct());
			this._draw();
		},

		/**
		 * @abstract
		 * @protected
		 */
		_draw: function(){
		} // override
	},
	Section
);

const SectionProfile = Class(
	/**
	 * @lends {SectionProfile#}
	 */
	{
		__NAME: 'SectionProfile',

		name: 'team',

		route: function(){
			if( !D.ID ){
				let get = new Get('/sign-in');
				get.add('redirect', this.url.href);
				Section.navigate(D.url(get.toUrl()));
				return false;
			}
			if( this.url.get.v('eventId') ){
				var get = new Get('/profile/event/' + this.url.get.v('eventId') + '?' + this.url.get.toStr());
				get.remove('eventId');
				Section.navigate(D.url(get.toUrl()));
				return;
			}

			let part = this.url.shift();
			switch( part ){
				case 'edit':
					return new SectionProfile.Edit();
				case 'affiliate':
					if (D.AFFILIATE_ENABLED) {
						return new SectionProfile.Affiliate();
					}
					return new SectionProfile.ActiveEvents();
				case 'event':
					return new SectionProfile.Event();
				case 'past':
					return new SectionProfile.PastEvents();
				case 'delete':
					return new SectionProfile.DeleteProfile();
				case 'events':
				default:
					return new SectionProfile.ActiveEvents();
			}
		}

	},
	SectionProfileBase
);

SectionProfile.Edit = Class(
	/**
	 * @lends {SectionProfile.Edit#}
	 */
	{
		__NAME: 'SectionProfile.Edit',

		name: 'edit',

		route: function(){
		},

		_draw: function(){
			new RPC('/api/web_rpc.php').send('getProfileData', {}, this._onData);
		},

		_onData: function(data){
			this.data = data.profileData;
			this._fields = {};
			this._formContainer = mkE({
				tag: 'div',
				className: 'profile-edit-container'
			}).append(this._content);
			this._form = mkE({
				tag: 'form',
				className: 'profile-edit-form',
				prop: {
					onsubmit: this._save
				},
				els: [
					{
						tag: 'div',
						className: 'left-col',
						els: [
							this._fields['name'] = new T.Form.Input({
								dark: true,
								caption: D.Lang.get('sign-up.form.name'),
								value: this.data.name
							}),
							this._fields['email'] = new T.Form.Input({
								dark: true,
								caption: D.Lang.get('sign-up.form.email'),
								value: this.data.email,
								type: 'email'
							}),
							this._fields['password'] = new T.Form.Input({
								dark: true,
								caption: D.Lang.get('sign-up.form.password'),
								type: 'password',
								placeholder: D.Lang.get('sign-up.form.password_placeholder')
							}),
							this._fields['password2'] = new T.Form.Input({
								dark: true,
								caption: D.Lang.get('sign-up.form.password2'),
								type: 'password'
							}),
							{
								tag: 'div',
								els: [
									{
										tag: 'button',
										className: 'button button-turquoise button-large',
										text: D.Lang.get('profile.profile.edit'),
										onclick: this._save
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'right-col',
						els: [
							new T.ProfilePic({
								type: 2,
								id: this.data.id,
								image: this.data.hasImage ? this.data.image : null,
								defaultImage: '/assets/images/default/user/m_ppl' + (this.data.id % 31 + 1) + '.png',
								canChange: true,
								errorHandler: this._picError
							})
						]
					}
				]
			}).append(this._formContainer);

			mkE({
				tag: 'div',
				className: 'profile-bottom',
				els: [
					{
						tag: 'a',
						href: D.url('/profile/delete'),
						className: 'profile-bottom-delete',
						text: D.Lang.get('profile.deleteProfile.btn')
					}
				]
			}).append(this._container);

			this._ready();
		},

		_picError: function(error){
			if( this._picErrorNode ){
				this._picErrorNode.remove();
			}
			if( error ){
				this._picErrorNode = T.error(error).prepend(this._formContainer);
			}
		},

		_save: function(){
			if( this._isSubmitting ){
				return false;
			}
			if( this._errorNode ){
				this._errorNode.remove();
			}
			if( this._successNode ){
				this._successNode.remove();
			}
			let data = {};
			let hasError = false;
			for( let field in this._fields ){
				if( !this._fields.hasOwnProperty(field) ){
					continue;
				}
				this._fields[field].error(null);
				if( !this._fields[field].value() && field !== 'password' && field !== 'password2' ){
					hasError = true;
					this._fields[field].error(D.Lang.get('sign-up.errors.empty'))
				}
				data[field] = this._fields[field].value();
			}
			if( data.password && data.password2 && data.password !== data.password2 ){
				hasError = true;
				this._fields['password2'].error(D.Lang.get('sign-up.errors.password_mismatch'))
			}
			if( hasError ){
				return false;
			}
			delete data.password2;
			this._isSubmitting = true;
			new RPC('/api/web_rpc.php').send('editProfile', data, this._onSubmit);
			return false;
		},

		_onSubmit: function(re){
			this._isSubmitting = false;
			if( empty(re) ){
				this._errorNode = T.error(D.Lang.get('profile.profile.errors.general')).prepend(this._formContainer);
				return;
			}
			if( re.ok ){
				if( re.emailChanged ){
					this._errorNode = T.error(D.Lang.get('profile.profile.email_changed')).prepend(this._formContainer);
				}
				this._successNode = T.success(D.Lang.get('profile.profile.edit_success')).prepend(this._formContainer);
				return;
			}
			if( !empty(re.error) ){
				if( typeof re.error === 'object' ){
					for( let field in re.error ){
						if( !re.error.hasOwnProperty(field) ){
							continue;
						}
						this._fields[field].error(D.Lang.get('sign-up.errors.' + field + '.' + re.error[field]));
					}
				} else{
					this._errorNode = T.error(D.Lang.get('profile.profile.errors.general')).prepend(this._formContainer);
				}
			}
		}
	},
	SectionProfileBase
);

SectionProfile.Events = Class(
	/**
	 * @lends {SectionProfile.Events#}
	 */
	{
		__NAME: 'SectionProfile.Events',

		_draw: function(){
			this.type = DR.events.GetEventsList.TYPE_MY_ACTIVE;
			this._load();
		},

		_load: function(){
			this._mGetMyData = new DR.users.GetMyData();
			this._mGetMyData.select = [
				new DR.users.select.MyData().user(),
				new DR.users.select.User().id().name()
			];
			this.apiCall.addMethod(this._mGetMyData);

			this._mGetEvents = new DR.events.GetEventsList();
			this._mGetEvents.type = this.type;
			this._mGetEvents.select = [
				new DR.events.select.Event().id().title().description().startTime().endTime().maxPlayers().minPlayers().seoTitle().status().showResults().settings(),
				new DR.teams.select.Team().id().results().maxPlayers(),
				new DR.roadgames.select.Image().small()
			];
			this.apiCall.addMethod(this._mGetEvents);

			this.apiCall.onLoad = this._onLoadApi;
			this.apiCall.call();
		},

		_onLoadApi: function(){
			if( this._mGetEvents.re.events.length ){
				this._drawItems();
			} else{
				this._drawEmpty();
			}

			mkE({
				tag: 'p',
				className: 'communities',
				innerHTML: D.Lang.get('profile.welcome.communities')
					.replace('%FACEBOOK%', '<a href="https://www.facebook.com/groups/372731283336637" target="_blank">facebook</a>')
			}).append(this._content);

			this._ready();
		},

		_drawItems: function(){
			mkE({
				tag: 'div',
				className: 'games-list',
				els: D.closure(this, function(){
					let re = [];
					for( let i = 0; i < this._mGetEvents.re.events.length; i++ ){
						const listItem = this._mGetEvents.re.events[i];
						const event = listItem.event;
						const team = listItem.team;
						const isOver = (event.status === 'ended' || event.status === 'finished') && event.showResults;
						const hasError = !isOver && team && team.users.length < event.minPlayers;
						let eventUrl = D.url('/profile/event/' + event.seoTitle);
						let resultsUrl = D.url('/profile/event/' + event.seoTitle + '/results');

						re.push({
							tag: 'div',
							className: 'item',
							els: [
								{
									tag: 'div',
									className: 'col',
									els: [
										{
											tag: 'div',
											className: 'col col-title',
											els: [
												{
													tag: 'div',
													className: 'item-status ' + (isOver ? '' : (hasError ? 'error' : 'success'))
												},
												{
													tag: 'a',
													className: 'item-title',
													href: eventUrl,
													text: event.title
												},
												event.settings.type !== 'anytime' ? {
													tag: 'div',
													className: 'item-info',
													els: [
														/*{
															tag: 'span',
															className: 'country cc-' + event.country
														},*/
														//D.Lang.get('iso.countries.' + event.country) + ', ',
														event.settings.hasUnknownDate ? D.Lang.get('profile.games.soon').toLowerCase() : D.Date.formatDateRange(event.startTime, event.endTime, 'j. %F, H:i', 'H:i', ' - ').toLowerCase()
													]
												} : null
											]
										}
									]
								},
								{
									tag: 'div',
									className: 'col',
									els: [
										{
											tag: 'div',
											className: 'col col-participants',
											els: [
												{
													tag: 'div',
													className: hasError ? 'error' : '',
													text: (team ? team.users.length : 0) + '/' + (team ? team.team.maxPlayers : event.maxPlayers)
												},
												{
													tag: 'span',
													text: D.Lang.get('profile.games.participants')
												}
											]
										},
										{
											tag: 'div',
											className: 'col col-status',
											els: [
												{
													tag: 'div',
													className: 'item-status ' + (isOver ? '' : (hasError ? 'error' : 'success'))
												}
											]
										},
										{
											tag: 'a',
											className: 'button ' + (isOver ? 'button-dark-grey' : 'button-turquoise'),
											text: D.Lang.get('profile.games.' + (isOver ? 'results' : (event.maxPlayers > 1 ? 'team' : 'info'))),
											href: isOver ? resultsUrl : eventUrl
										}
									]
								}
							]
						});
					}
					return re;
				})()
			}).append(this._content);
		},

		_drawEmpty: function(){
			mkE({
				tag: 'div',
				className: 'games-header',
				els: [
					{
						tag: 'h2',
						els: [
							D.Lang.get('profile.games.empty.hello').replace('%NAME%', this._mGetMyData.re.user.name)
						]
					},
					{
						tag: 'p',
						text: D.Lang.get('profile.games.empty.description')
					},
					{
						tag: 'a',
						className: 'button button-pink button-large',
						href: D.url('/events'),
						text: D.Lang.get('profile.games.empty.join')
					}
				]
			}).append(this._content);
		}
	},
	SectionProfileBase
);

SectionProfile.ActiveEvents = Class(
	/**
	 * @lends {SectionProfile.ActiveEvents#}
	 */
	{
		__NAME: 'SectionProfile.ActiveEvents',

		name: 'activeEvents',

		_draw: function(){
			this.type = DR.events.GetEventsList.TYPE_MY_ACTIVE;
			this._load();
		},

		_drawItems: function(){
			mkE({
				tag: 'div',
				className: 'games-header',
				els: [
					{
						tag: 'h2',
						className: 'menu-title',
						els: [
							D.Lang.get('profile.games.active.hello').replace('%NAME%', this._mGetMyData.re.user.name)
						]
					},
					{
						tag: 'h2',
						className: 'menu-title-mobile',
						text: D.Lang.get('profile.menu.activeEvents')
					},
					{
						tag: 'p',
						text: D.Lang.get('profile.games.active.description')
					}
				]
			}).append(this._content);
			PARENT._drawItems();
		}
	},
	SectionProfile.Events
);

SectionProfile.PastEvents = Class(
	/**
	 * @lends {SectionProfile.PastEvents#}
	 */
	{
		__NAME: 'SectionProfile.PastEvents',

		name: 'pastEvents',

		_draw: function(){
			this.type = DR.events.GetEventsList.TYPE_MY_PAST;
			this._load();
		},

		_drawItems: function(){
			mkE({
				tag: 'div',
				className: 'games-header',
				els: [
					{
						tag: 'h2',
						className: 'menu-title',
						els: [
							D.Lang.get('profile.games.past.hello').replace('%NAME%', this._mGetMyData.re.user.name)
						]
					},
					{
						tag: 'h2',
						className: 'menu-title-mobile',
						text: D.Lang.get('profile.menu.pastEvents')
					},
					{
						tag: 'p',
						text: D.Lang.get('profile.games.past.description')
					}
				]
			}).append(this._content);
			PARENT._drawItems();
		},

		_drawEmpty: function(){
			mkE({
				tag: 'div',
				className: 'games-header',
				els: [
					{
						tag: 'h2',
						els: [
							D.Lang.get('profile.games.empty.hello').replace('%NAME%', this._mGetMyData.re.user.name)
						]
					},
					{
						tag: 'p',
						text: D.Lang.get('profile.games.empty.description_past')
					},
					{
						tag: 'a',
						className: 'button button-pink button-large',
						href: D.url('/events'),
						text: D.Lang.get('profile.games.empty.join')
					}
				]
			}).append(this._content);
		}
	},
	SectionProfile.Events
);

SectionProfile.DeleteProfile = Class(
	/**
	 * @lends {SectionProfile.DeleteProfile#}
	 */
	{
		__NAME: 'SectionProfile.DeleteProfile',

		_draw: function(){
			this.node = mkE({
				tag: 'div',
				className: 'profile-delete',
				els: [
					{
						tag: 'div',
						className: 'games-header',
						els: [
							{
								tag: 'h2',
								text: D.Lang.get('profile.deleteProfile.title')
							},
							{
								tag: 'p',
								text: D.Lang.get('profile.deleteProfile.description')
							}
						]
					},
					{
						tag: 'div',
						className: 'bottom',
						els: [
							{
								tag: 'a',
								className: 'back',
								href: D.url('/profile')
							},
							{
								tag: 'span',
								className: 'button button-pink button-large button-block',
								onclick: this._onClickDelete,
								text: D.Lang.get('profile.deleteProfile.btn')
							}
						]
					}
				]
			}).append(this._content);

			this._ready();
		},

		_onClickDelete: function(){
			if( confirm(D.Lang.get('profile.deleteProfile.confirm')) ){
				new RPC('/api/web_rpc.php').send('deleteProfile', {csrf: D.DS}, this._onDeleteProfileRe);
			}
		},

		_onDeleteProfileRe: function(re){
			if( re.ok ){
				window.location = D.url('/sign-in');
			} else{
				alert(D.Lang.get('profile.deleteProfile.system_error'));
			}
		}

	},
	SectionProfileBase
);